import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FileStorageInjectionToken, FileStorageServiceInterface } from '../../interfaces/file-storage.interface';
import { EquipmentModel } from '../../models/complex/equipment.model';
import { ODataSoftwareLicenceSet } from './software-licence.model';

@Injectable()
export class SoftwareLicencesStorageService {
    private readonly fileNameSeparator = '-';
    public constructor(@Inject(FileStorageInjectionToken) private readonly fileStorage: FileStorageServiceInterface) {}

    public saveSoftwareLicencesToCache(
        equipment: EquipmentModel,
        data: ODataSoftwareLicenceSet[],
    ): Observable<ODataSoftwareLicenceSet[]> {
        const storageId = this.getSoftwareLicenceStorageId(equipment);
        return this.fileStorage.storeCompressedData(storageId, data);
    }

    public loadSoftwareLicencesFromCache(equipment: EquipmentModel): Observable<ODataSoftwareLicenceSet[] | undefined> {
        const storageId = this.getSoftwareLicenceStorageId(equipment);
        return this.fileStorage
            .loadCompressedData<ODataSoftwareLicenceSet[]>(storageId)
            .pipe(catchError(() => of(undefined)));
    }

    private getSoftwareLicenceStorageId(equipment: EquipmentModel): string {
        return `SoftwareLicenceOdata${this.fileNameSeparator}${equipment.matnr.value}${this.fileNameSeparator}${equipment.sernr.value}`;
    }
}
